import {create, StateCreator} from 'zustand';
import {devtools} from 'zustand/middleware';
import {isDevMode} from 'common/constants';

type State = Record<string, unknown>;

export const createState = <T extends State>(
	name: string,
	fn: StateCreator<T, [['zustand/devtools', never]], []>
) =>
		isDevMode
			? create(devtools(fn, {name, anonymousActionType: `${name}/action`}))
			: create(fn);